// Development authentication bypass - ONLY for local development
// SECURITY: Multiple guards prevent this from ever activating in production:
// 1. NODE_ENV must be 'development' (CRA sets 'production' in prod builds)
// 2. Hostname must be localhost/127.0.0.1 (blocks deployed domains)
// 3. REACT_APP_E2E_MODE only enables isDevelopment, still requires localhost
import { auth0Claims, userRoles } from './auth/consts'

const isLocalhost = typeof window !== 'undefined' && (
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1' ||
  window.location.hostname === '[::1]'
)

export const isDevelopment = isLocalhost && (
  process.env.NODE_ENV === 'development' ||
  process.env.REACT_APP_E2E_MODE === 'true'
)

// Available organizations for dev mode switching
export const devOrganizations = [
  'Veta Virtual Mainline CA',
  'Veta Virtual Mainline US'
]

// Get current dev organization from localStorage or default
export const getDevOrganization = () => {
  if (!isDevelopment) return devOrganizations[0]
  return localStorage.getItem('dev_organization') || devOrganizations[0]
}

// Get current dev role from localStorage or default to admin
export const getDevRole = () => {
  if (!isDevelopment) return null
  const role = localStorage.getItem('dev_role')
  return role === 'user' ? null : userRoles.ADMINISTRATOR
}

// Build mock user with current dev settings
const buildMockUser = () => ({
  sub: 'dev|local-user',
  email: 'dev@vetavirtual.com',
  name: 'Dev User',
  picture: 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100"><rect width="100" height="100" rx="50" fill="#1e3a5f"/><text x="50" y="58" text-anchor="middle" fill="#fff" font-family="system-ui" font-size="40" font-weight="600">DU</text></svg>'),
  nickname: 'dev',
  email_verified: true,
  given_name: 'Dev',
  family_name: 'User',
  locale: 'en',
  [auth0Claims.authorizationClaim]: {
    organization: getDevOrganization(),
    roles: getDevRole() ? [getDevRole()] : []
  },
  [auth0Claims.userAuthClaim]: {
    user_metadata: {
      Organization: getDevOrganization()
    }
  },
  [auth0Claims.rolesClaim]: getDevRole() ? [getDevRole()] : []
})

// Check for dev bypass - requires both isDevelopment AND localStorage flag
export const shouldBypassAuth = () => {
  if (!isDevelopment) return false
  return localStorage.getItem('dev_bypass') === 'true'
}

// Auto-activate dev bypass in development mode (localhost only)
if (isDevelopment && localStorage.getItem('dev_bypass') !== 'false') {
  localStorage.setItem('dev_bypass', 'true')
}

// Mock Auth0 hook for development
export const useMockAuth0 = () => {
  if (!shouldBypassAuth()) return null

  return {
    isAuthenticated: true,
    isLoading: false,
    user: buildMockUser(),
    error: null,
    loginWithRedirect: () => Promise.resolve(),
    logout: () => {
      localStorage.setItem('dev_bypass', 'false')
      window.location.reload()
    },
    getAccessTokenSilently: () => Promise.resolve('mock-token'),
    getIdTokenClaims: () => Promise.resolve({ __raw: 'mock-token' })
  }
}
